/**
 * @name results.controller:horseTable
 * @description
 * # horseTable
 * Controller for horseTable block directive
 */
export default function ($scope,
                         ugc,
                         userPreference
                        ) {
    'ngInject';

    $scope.generalInfo = {
        length: null,
        note: {
            isExists: null,
            value: null
        }
    };

    angular.extend($scope, window.horseData);
    delete window.horseData;

    ugc.rpNavigationAuthReady().then((auth) => {
        if (!auth.user.isLoggedIn) {
            return;
        }

        ugc.checkNotes().then(response => {
            const {
                customer_results_notes: hasCustomerNotes,
                customer_race_results_notes: hasRaceNotes
            } = response.data.hasNotes || {};

            if (!hasCustomerNotes && !hasRaceNotes) {
                return;
            }

            ugc.get($scope.raceId).success((data) => {
                if (Array.isArray(data.runnerNotes)) {
                    data.runnerNotes.forEach((runnerRecord) => {
                        const item = $scope.items.find(({ runnerInfo }) =>
                            runnerInfo.horseId === +runnerRecord.horseId
                        );
                        if (item) {
                            item.runnerInfo.rating = runnerRecord.rating;
                        }
                    });
                }
            });
        });
    });

    /**
     * Returns pedigrees state
     * @return {Boolean}
     */
    $scope.getPedigreesState = () => userPreference.get(userPreference.TYPE_PEDIGREE);

    /**
     * Returns comments state
     * @return {Boolean}
     */
    $scope.getCommentsState = () => userPreference.get(userPreference.TYPE_COMMENTS);
}



// WEBPACK FOOTER //
// ./src/js/controllers/horseTable.js